module.exports = __webpack_public_path__ + "img/country-insights-verifications.51ed88eb.jpg";